import { render, staticRenderFns } from "./MassenMailEmpfaengerAbsender.vue?vue&type=template&id=6e0685f6"
import script from "./MassenMailEmpfaengerAbsender.vue?vue&type=script&lang=js"
export * from "./MassenMailEmpfaengerAbsender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports